const ALL_FILTER = "all";
const PLATE = "plate";

const SETTINGS = "settings";

const SPICY = "Spicy";

const COMBO_FILTER = "Combo";

export { ALL_FILTER, COMBO_FILTER, PLATE, SETTINGS, SPICY };
